import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon, QuoteIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, IMAGES, PRICES, modules, testimonials } from '../data/funnel';
import { formatUsd } from '../utils/currency';
import { trackAddToCart } from '../utils/metaPixel';
const painPoints = ['Ronca, jadea y se agota en caminatas de 10 minutos.', 'Se rasca los pliegues hasta dejarse la piel roja.', 'Duda antes de subir al sofá o arrastra las patas al levantarse.', 'Cada visita al veterinario termina en otra factura de tres cifras.'];
export function SalesPage() {
  function handleAddToCart(event: React.MouseEvent<HTMLAnchorElement>) {
    // Deja que el navegador maneje cmd/ctrl/middle click en una pestaña nueva.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    trackAddToCart({
      content_name: 'Protocolo de Biohacking para Bulldogs Franceses',
      content_ids: ['44410140852289'],
      value: PRICES.blueprint
    });
    // Pequeña espera para que el evento salga antes de abandonar la página.
    window.setTimeout(() => {
      window.location.href = CHECKOUT_URL;
    }, 250);
  }
  return <main className="w-full bg-cream pb-24" data-id="element-229" data-mp="30uosozet3jrs">
      <div className="bg-navy-deep text-paper" data-id="element-230" data-mp="30rkkzs24u5wd">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-2 px-5 py-2.5 text-center text-xs font-medium text-gold-pale sm:text-sm" data-id="element-231" data-mp="2vvvhxeqwm6vb">
          <ZapIcon className="h-3.5 w-3.5 text-gold" data-id="element-232" data-mp="3ojraq8dcremt" />
          Oferta de lanzamiento: <strong className="font-bold text-paper" data-id="element-233" data-mp="3oholvrnxrrjo">85% de descuento</strong>{' '}
          para dueños en USA · solo esta semana
        </div>
      </div>

      <section className="mx-auto max-w-6xl px-5 pt-12 sm:pt-16" data-id="element-234" data-mp="3fi1hqy3to7mx">
        <div className="grid items-center gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-14" data-id="element-235" data-mp="284znsayz6zkw">
          <div data-id="element-236" data-mp="243nyy7nxeidr">
            <h1 className="font-display text-[2rem] font-bold leading-[1.12] tracking-tight text-navy-deep sm:text-[2.9rem]" data-id="element-237" data-mp="2434pzgg974bv">
              El plan de 30 días que protege la columna, la respiración y la piel de tu Bulldog
              Francés
            </h1>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-navy/75" data-id="element-238" data-mp="2ahtrgimv0jxk">
              El Protocolo de Biohacking traduce lo que hacen los dueños de Frenchies de 12 y 14
              años en una rutina diaria de 7 minutos, con el{' '}
              <strong className="font-semibold text-navy-deep" data-id="element-239" data-mp="1mu25soffiujm">Protocolo Spine-Shield</strong> como
              núcleo.
            </p>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-240" data-mp="1rmlm3t5i43s4">
              {['Rutina diaria de 7 minutos', 'Transición de dieta semana por semana', 'Protocolo de calor para verano', 'Acceso inmediato en PDF + móvil'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-navy-deep/85" data-id="element-241" data-mp="13xkf8acbh0oy">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-242" data-mp="17z5ollpn6wue" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-3" data-id="element-243" data-mp="kapouujmd51j">
              <a href={CHECKOUT_URL} onClick={handleAddToCart} className="group inline-flex items-center justify-center gap-2 rounded-lg bg-navy-deep px-7 py-4 text-base font-bold text-paper shadow-card transition-colors duration-150 ease-out hover:bg-navy sm:text-lg" data-id="element-244" data-mp="y9ysyvujw8p5">
                Quiero el protocolo por ${formatUsd(PRICES.blueprint)}
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-245" data-mp="1h0glazbh129z" />
              </a>
              <p className="text-sm text-navy/60" data-id="element-246" data-mp="1cyv79an7ahy7">
                <span className="line-through" data-id="element-247" data-mp="1qxl6avtkyrp7">${formatUsd(PRICES.blueprintValue)}</span> hoy{' '}
                <strong className="font-bold text-navy-deep" data-id="element-248" data-mp="1lzjp6gfpt2gd">
                  ${formatUsd(PRICES.blueprint)}
                </strong>
              </p>
            </div>
          </div>

          <div className="justify-self-center" data-id="element-249" data-mp="2a2pxgc52jv27">
            <img src={IMAGES.cover} alt="El Protocolo de Biohacking para Bulldogs Franceses, plan de 30 días, en ebook y tablet" className="w-full max-w-md rounded-xl shadow-lift" data-id="element-250" data-mp="2a1eu2dfjcpbm" />
          </div>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-251" data-mp="1n31tm6gff9rk">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-start lg:gap-16" data-id="element-252" data-mp="1n4moxyakewqh">
          <div data-id="element-253" data-mp="1r5ybtw2213uz">
            <h2 className="font-display text-2xl font-bold leading-snug text-navy-deep sm:text-3xl" data-id="element-254" data-mp="1w2yfy1fcfwjg">
              Si reconoces dos o más de estas señales, el reloj ya está corriendo
            </h2>
            <ul className="mt-6 space-y-3" data-id="element-255" data-mp="37i3vi60kppkh">
              {painPoints.map(p => <li key={p} className="flex items-start gap-3 border-l-2 border-alert/60 pl-4 text-base leading-relaxed text-navy/80" data-id="element-256" data-mp="37khng5zyilnt">
                  {p}
                </li>)}
            </ul>
          </div>
          <figure className="overflow-hidden rounded-xl" data-id="element-257" data-mp="vvjv6c1obl78">
            <img src={IMAGES.food} alt="Ingredientes frescos de comida natural para perro sobre una mesada de piedra clara" className="aspect-[3/2] w-full object-cover" data-id="element-258" data-mp="r39zefdvnqx1" />
            <figcaption className="mt-2 text-sm leading-relaxed text-navy/60" data-id="element-259" data-mp="i453zhxm4dp3">
              El protocolo no exige cocinar todos los días. Empieza retirando tres ingredientes de
              la croqueta que tu perro ya come.
            </figcaption>
          </figure>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-260" data-mp="37e7phj8ji3p">
        <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-261" data-mp="22iyl73feajw9">
          Qué hay dentro del protocolo
        </h2>
        <p className="mt-2 max-w-2xl text-base text-navy/65" data-id="element-262" data-mp="1xlf6y3ip674b">
          Cinco bloques que se ejecutan en orden. Cada uno toma menos de una tarde en configurar.
        </p>

        <ol className="mt-8 space-y-px overflow-hidden rounded-xl bg-navy-deep/10" data-id="element-263" data-mp="m6g85wf5coj">
          {modules.map(m => <li key={m.number} className="grid gap-2 bg-paper p-6 sm:grid-cols-[auto_1fr] sm:gap-6 sm:p-7" data-id="element-264" data-mp="3i37osl2oasr8">
              <span className="font-display text-lg font-bold text-gold sm:pt-0.5" data-id="element-265" data-mp="3myws8zhtctst">{m.number}</span>
              <div data-id="element-266" data-mp="jkito3ud58px">
                <h3 className="font-display text-lg font-bold text-navy-deep" data-id="element-267" data-mp="jl2djq3kq76l">{m.title}</h3>
                <p className="mt-1.5 max-w-2xl text-[0.95rem] leading-relaxed text-navy/70" data-id="element-268" data-mp="5l1ac3zu6nny">
                  {m.description}
                </p>
              </div>
            </li>)}
        </ol>
      </section>

      <section className="mx-auto mt-20 max-w-6xl px-5" data-id="element-269" data-mp="2qaqmuad2hxdh">
        <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-270" data-mp="2qdcvkdbp2ixa">
          Dueños que ya dejaron de reaccionar
        </h2>
        <div className="mt-8 grid gap-6 lg:grid-cols-[1.25fr_1fr]" data-id="element-271" data-mp="2ms1c5p4s9aco">
          <figure className="flex flex-col overflow-hidden rounded-xl bg-navy-deep text-paper" data-id="element-272" data-mp="2hu87j0j4ooei">
            <img src={testimonials[0].photo} alt={`${testimonials[0].name} abrazando a su Bulldog Francés en casa`} className="aspect-[4/3] w-full object-cover" data-id="element-273" data-mp="2wr8ruiyzph2y" />
            <blockquote className="flex flex-1 flex-col p-6 sm:p-7" data-id="element-274" data-mp="2421s5gnsulg4">
              <QuoteIcon className="h-5 w-5 text-gold" data-id="element-275" data-mp="2408ma3l0g596" />
              <p className="mt-3 font-display text-lg leading-relaxed sm:text-xl" data-id="element-276" data-mp="1z4t5b2rpht8j">
                {testimonials[0].quote}
              </p>
              <figcaption className="mt-auto pt-5 text-sm text-gold-pale" data-id="element-277" data-mp="2du7f2bz72cog">
                <span className="font-semibold text-paper" data-id="element-278" data-mp="290d2rtlx4zze">{testimonials[0].name}</span> ·{' '}
                {testimonials[0].location} · {testimonials[0].dogAge}
              </figcaption>
            </blockquote>
          </figure>

          <div className="grid gap-6" data-id="element-279" data-mp="utxirv7wk9zd">
            {testimonials.slice(1).map(t => <figure key={t.name} className="flex h-full flex-col rounded-xl border border-navy-deep/10 bg-paper p-6" data-id="element-280" data-mp="zsqxfqyxe714">
                <p className="text-[0.95rem] leading-relaxed text-navy/80" data-id="element-281" data-mp="14qk2ggohsuzt">“{t.quote}”</p>
                <figcaption className="mt-auto pt-4 text-sm text-navy/55" data-id="element-282" data-mp="18v076emddwdg">
                  <span className="font-semibold text-navy-deep" data-id="element-283" data-mp="1dtbeahla5srz">{t.name}</span> · {t.location} ·{' '}
                  {t.dogAge}
                </figcaption>
              </figure>)}
          </div>
        </div>
      </section>

      <section className="mx-auto mt-20 max-w-3xl px-5" data-id="element-284" data-mp="1nj4phhhig5vp">
        <div className="rounded-2xl border border-navy-deep/10 bg-paper p-7 shadow-card sm:p-10" data-id="element-285" data-mp="1shpiowychpan">
          <h2 className="font-display text-2xl font-bold text-navy-deep sm:text-3xl" data-id="element-286" data-mp="1wjswvtcef7zm">
            Tu acceso hoy
          </h2>
          <dl className="mt-6 divide-y divide-navy-deep/10 border-y border-navy-deep/10" data-id="element-287" data-mp="21inlxd0ylss6">
            <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-288" data-mp="3m0y5v7ua3mux">
              <dt className="text-[0.95rem] text-navy/80" data-id="element-289" data-mp="3h0sk28aowukr">
                Protocolo de Biohacking — Plan de 30 días
              </dt>
              <dd className="shrink-0 text-sm text-navy/55" data-id="element-290" data-mp="3czqlzusieokd">
                ${formatUsd(PRICES.blueprintValue)}
              </dd>
            </div>
            <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-291" data-mp="8ls42coq5cde">
              <dt className="text-[0.95rem] text-navy/80" data-id="element-292" data-mp="4jnblha0ilsc">
                Checklist de longevidad imprimible + calendario de 30 días
              </dt>
              <dd className="shrink-0 text-sm text-navy/55" data-id="element-293" data-mp="3vx1gz373yvu0">Incluido</dd>
            </div>
            <div className="flex items-baseline justify-between gap-4 py-3" data-id="element-294" data-mp="3qy6t3muaah31">
              <dt className="text-[0.95rem] text-navy/80" data-id="element-295" data-mp="s9rhxwel4zn1">
                Actualizaciones de por vida del protocolo
              </dt>
              <dd className="shrink-0 text-sm text-navy/55" data-id="element-296" data-mp="ngyc157drl9d">Incluido</dd>
            </div>
          </dl>

          <div className="mt-6 flex flex-wrap items-end justify-between gap-4" data-id="element-297" data-mp="31erqklxj02tu">
            <div data-id="element-298" data-mp="2wggjuk2j28fu">
              <p className="text-sm font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-299" data-mp="2wgzqh4mq9aek">
                Hoy pagas
              </p>
              <p className="font-display text-5xl font-bold leading-none text-navy-deep" data-id="element-300" data-mp="36dcmi95qw0ch">
                ${formatUsd(PRICES.blueprint)}
              </p>
            </div>
            <p className="text-sm text-navy/60" data-id="element-301" data-mp="3kb151accaved">Pago único · sin suscripción</p>
          </div>

          <a href={CHECKOUT_URL} onClick={handleAddToCart} className="group mt-7 flex w-full items-center justify-center gap-2 rounded-lg bg-gold px-6 py-4 text-lg font-bold text-navy-deep transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-302" data-mp="3fdr8zbug3lhk">
            Empezar el protocolo hoy
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-303" data-mp="1zef3kzl66jr" />
          </a>

          <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-navy/55" data-id="element-304" data-mp="lm7ubamx9afb">
            <span className="flex items-center gap-1.5" data-id="element-305" data-mp="qioho2markrc">
              <ShieldCheckIcon className="h-4 w-4 text-navy/40" data-id="element-306" data-mp="ck89e78sdm73" />
              Garantía de 30 días sin preguntas
            </span>
            <span className="flex items-center gap-1.5" data-id="element-307" data-mp="gks99ikqv3wx">
              <LockIcon className="h-4 w-4 text-navy/40" data-id="element-308" data-mp="2uf1bg7urp7l" />
              Pago cifrado
            </span>
          </div>
        </div>
      </section>

      <footer className="mx-auto mt-16 max-w-3xl px-5 text-xs leading-relaxed text-navy/45" data-id="element-309" data-mp="7lx2a49vlpsk">
        Material educativo. No sustituye la consulta veterinaria. © {new Date().getFullYear()} The
        Frenchie Longevity Report.
      </footer>
    </main>;
}